export default __webpack_public_path__ + "static/media/twitter.a803a369.svg";